import { feedCards } from '@/mocks/home';
import SectionHeading from './SectionHeading';

export default function FeedGrid() {
  return (
    <section className="border-b border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1400px] px-4 py-10 md:px-6 md:py-14">
        <SectionHeading
          id="feed"
          eyebrow="事件始末"
          title="最新大图卡片流 · 一条一条看明白"
          desc="每条都标出所属阶段与信息来源，点开即可看到该事件的完整时间线与关键截图。"
          action="更多爆料"
        />

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 lg:gap-5">
          {feedCards.map((card, index) => (
            <article
              key={card.title}
              className="group flex animate-rise cursor-pointer flex-col overflow-hidden rounded-lg border border-background-300 bg-background-50 transition-colors hover:border-primary-300"
              style={{ animationDelay: `${0.05 * (index % 3)}s` }}
            >
              <div className="relative h-48 w-full overflow-hidden md:h-52">
                <img
                  src={card.image}
                  alt={card.title}
                  title={`${card.tag} ${card.title} 黑料爆料`}
                  className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-background-50/95 px-2.5 py-1 text-[11px] font-bold text-primary-700">
                  {card.tag}
                </span>
                {card.badge ? (
                  <span className="absolute right-3 top-3 flex items-center gap-1 rounded-full bg-primary-500 px-2.5 py-1 text-[11px] font-bold text-background-50">
                    <span className="h-1.5 w-1.5 animate-blip rounded-full bg-background-50" />
                    {card.badge}
                  </span>
                ) : null}
              </div>

              <div className="flex flex-1 flex-col p-4 md:p-5">
                <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 group-hover:text-primary-700">
                  {card.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{card.excerpt}</p>

                <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-1 border-t border-background-200 pt-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-price-tag-3-line text-sm text-secondary-600" />
                    {card.source}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line text-sm" />
                    {card.time}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line text-sm" />
                    {card.views}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-3-line text-sm" />
                    {card.comments}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}